import React from "react";
import Breadcrumb from "./Breadcrumb";

const CharterPage = () => {
  return (
    <>
      <Breadcrumb currentPage="Устав" />
      <div className="charter-page wrapper">
        <header className="charter-header">
          <h2>УТВЕРЖДЕН</h2>
          <p>Общим собранием учредителей</p>
          <p>19 марта 2018 года</p>
          <h2>Устав Международной Бизнес Ассоциации "Альянс предпринимателей СНГ"</h2>
          <p>Москва, 2018 год</p>
        </header>

        <main className="charter-content">
          <section className="charter-section">
            <h2>1. Общие положения</h2>

            <p>
              1.1. Международная Бизнес Ассоциация «Альянс предпринимателей СНГ»
              (далее — Ассоциация) является независимой социально ориентированной
              некоммерческой организацией, созданной в организационно-правовой
              форме союза, основанной на добровольном и селективном участии
              предпринимателей, обладающих значительными профессиональными
              достижениями и признанием в бизнес-сообществе.
            </p>

            <p>
              1.2. Ассоциация объединяет предпринимателей, инвесторов,
              руководителей компаний и профессиональные объединения из стран СНГ и
              других государств, продемонстрировавших высокий уровень деловой
              активности, устойчивые результаты и вклад в развитие отраслей
              экономики, с целью развития международного делового сотрудничества,
              формирования профессиональных стандартов и укрепления экономических
              связей.
            </p>

            <p>
              1.3. Деятельность Ассоциации направлена на выявление, объединение и
              профессиональное признание предпринимателей, оказывающих значительное
              влияние на развитие бизнеса, внедрение инноваций и формирование
              современной деловой среды на национальном и международном уровнях.
            </p>

            <p>
              1.4. Ассоциация осуществляет свою деятельность в соответствии с
              Конституцией Российской Федерации, федеральными законами «О
              некоммерческих организациях», «Об объединениях работодателей»,
              законодательствами государств-участников СНГ, а также настоящим
              Уставом.
            </p>

            <p>
              1.5. Настоящий Устав является основным документом, регулирующим
              деятельность Ассоциации, включая порядок членства, процедуры
              экспертной оценки и принятия решений, и обязателен для исполнения
              всеми членами Ассоциации.
            </p>

            <p>1.6. Полное официальное наименование Ассоциации:</p>
            <ul>
              <li>
                На русском языке: Международная Бизнес Ассоциация «Альянс
                предпринимателей СНГ».
              </li>
              <li>
                На английском языке: International Business Association "CIS
                Entrepreneurs Alliance".
              </li>
            </ul>

            <p>1.7. Местонахождение Ассоциации: Российская Федерация, город Москва.</p>

            <p>
              1.8. Ассоциация создается на неопределенный срок и осуществляет свою
              деятельность на международном уровне.
            </p>
          </section>

          <section className="charter-section">
            <h2>2. Цели и задачи Ассоциации</h2>

            <p>
              2.1. Основной целью Ассоциации является формирование международной
              профессиональной платформы, объединяющей предпринимателей и
              бизнес-лидеров, продемонстрировавших значительные достижения и
              признание, для развития международного бизнеса и укрепления
              экономического сотрудничества.
            </p>

            <p>
              2.2. Ассоциация направлена на выявление, объединение и
              профессиональное признание предпринимателей, оказывающих существенное
              влияние на развитие отраслей экономики, внедрение инноваций и
              формирование современных бизнес-практик.
            </p>

            <p>2.3. В рамках своей деятельности Ассоциация решает следующие задачи:</p>
            <ul>
              <li>
                создание и развитие международной экспертной платформы для
                взаимодействия предпринимателей, инвесторов и руководителей
                компаний, способствующей обмену передовыми практиками и
                стратегическими инициативами;
              </li>
              <li>
                организация и проведение экспертной оценки достижений
                предпринимателей, компаний и бизнес-проектов с привлечением
                профильных комитетов и профессиональных жюри;
              </li>
              <li>
                укрепление сотрудничества между представителями бизнеса,
                государственными органами и международными организациями с целью
                формирования благоприятной деловой среды и инвестиционного
                климата;
              </li>
              <li>
                содействие обмену профессиональными знаниями, технологиями и
                управленческими решениями между участниками Ассоциации;
              </li>
              <li>
                представление и защита интересов членов Ассоциации на
                международном уровне, включая участие в формировании отраслевых
                инициатив и бизнес-повестки;
              </li>
              <li>
                организация международных форумов, отраслевых конференций,
                экспертных панелей, обучающих программ и специализированных
                мероприятий, направленных на развитие предпринимательства и
                повышение профессионального уровня участников;
              </li>
              <li>
                разработка и реализация программ поддержки и развития бизнеса,
                включая малый и средний бизнес, с учетом современных
                международных стандартов;
              </li>
              <li>
                содействие внедрению инновационных технологий, цифровых решений и
                интеллектуальных систем, направленных на повышение эффективности
                и конкурентоспособности бизнеса;
              </li>
              <li>
                формирование и развитие профессиональных стандартов в сфере
                предпринимательства, управления и инноваций.
              </li>
            </ul>
          </section>

          <section className="charter-section">
            <h2>3. Членство в Ассоциации</h2>

            <h3>3.1. Общие положения о членстве</h3>
            <p>
              3.1.1. Членство в Ассоциации носит строго селективный и ограниченный
              характер и предоставляется исключительно предпринимателям и
              бизнес-лидерам, продемонстрировавшим выдающиеся профессиональные
              достижения, значительный вклад в развитие отрасли и получившим
              признание в профессиональном сообществе на национальном или
              международном уровне.
            </p>
            <p>
              3.1.2. Прием в члены Ассоциации осуществляется только по результатам
              многоэтапной процедуры отбора, включающей обязательную экспертную
              оценку профессиональных достижений кандидата признанными экспертами и
              действующими членами Ассоциации, обладающими высоким уровнем
              профессионального авторитета.
            </p>
            <p>
              3.1.3. Ассоциация объединяет ограниченный круг предпринимателей,
              соответствующих высоким стандартам профессиональной исключительности,
              при этом членство рассматривается как форма профессионального
              признания достижений кандидата со стороны экспертного сообщества.
            </p>
            <p>
              3.1.4. Оценка кандидатов осуществляется не на основании формальных
              показателей, а с учетом совокупности их достижений, уровня влияния на
              развитие бизнеса, инновационной деятельности и степени признания в
              отрасли.
            </p>

            <h3>3.2. Критерии членства</h3>
            <p>
              3.2.1. Членство в Ассоциации предоставляется исключительно
              кандидатам, продемонстрировавшим высокий уровень профессионального
              признания и значительные достижения в предпринимательской
              деятельности.
            </p>
            <p>
              Кандидат на вступление в Ассоциацию должен соответствовать
              совокупности следующих критериев:
            </p>
            <ul>
              <li>
                подтвержденная безупречная деловая репутация и финансовая
                устойчивость, подтверждаемая документально за предыдущие периоды
                деятельности;
              </li>
              <li>
                наличие выдающихся профессиональных достижений, подтвержденных
                получением национальных или международных наград, премий либо
                иных форм официального признания профессионального сообщества;
              </li>
              <li>
                наличие публикаций, интервью или упоминаний о профессиональной
                деятельности кандидата в авторитетных деловых, отраслевых или
                международных средствах массовой информации;
              </li>
              <li>
                подтвержденный значительный вклад в развитие отрасли, включая
                внедрение инновационных решений, создание или развитие успешных
                бизнес-моделей, либо реализацию масштабных бизнес-проектов;
              </li>
              <li>
                наличие устойчивого бизнеса с годовым оборотом не менее 300 000
                долларов США как дополнительного подтверждения уровня
                профессиональной деятельности;
              </li>
              <li>
                наличие рекомендаций от действующих членов Ассоциации или
                признанных экспертов в соответствующей области, подтверждающих
                уровень достижений и профессионального признания кандидата.
              </li>
            </ul>
            <p>
              3.2.2. Оценка соответствия кандидата указанным критериям
              осуществляется на основе всестороннего анализа совокупности его
              достижений, уровня профессионального признания и влияния на развитие
              отрасли, проводимого Комитетом по приему в члены Ассоциации с
              участием признанных экспертов.
            </p>
            <p>
              3.2.3. Наличие формального соответствия отдельным критериям не
              является достаточным основанием для приема в Ассоциацию. Решение
              принимается исключительно при подтверждении высокого уровня
              профессиональной исключительности кандидата и его признания в
              профессиональном сообществе.
            </p>

            <h3>3.3. Комитет по приему в члены Ассоциации</h3>
            <p>
              3.3.1. В целях обеспечения объективной и профессиональной оценки
              кандидатов в Ассоциации создается Комитет по приему в члены
              Ассоциации (далее - Комитет).
            </p>
            <p>
              3.3.2. Комитет является экспертным органом Ассоциации и осуществляет
              рассмотрение кандидатур, оценку профессиональных достижений, уровня
              признания, деловой репутации и соответствия кандидатов установленным
              критериям членства.
            </p>
            <p>
              3.3.3. Комитет формируется из числа действующих членов Ассоциации,
              обладающих признанным профессиональным авторитетом, значительными
              достижениями в предпринимательской деятельности и подтвержденным
              опытом в соответствующих отраслях в количестве 3-х человек.
            </p>
            <p>3.3.4. Членами Комитета могут быть только лица, соответствующие следующим требованиям:</p>
            <ul>
              <li>наличие значительных профессиональных достижений в бизнесе;</li>
              <li>
                признание в профессиональном сообществе, подтверждаемое наградами,
                публикациями, участием в профессиональных объединениях,
                экспертных советах или жюри;
              </li>
              <li>безупречная деловая репутация;</li>
              <li>
                опыт оценки бизнес-проектов, стратегий или профессиональной
                деятельности;
              </li>
              <li>
                отсутствие конфликта интересов и соблюдение принципов
                независимости и объективности.
              </li>
            </ul>
            <p>
              3.3.5. Члены Комитета избираются Общим собранием членов Ассоциации
              из числа кандидатов, предложенных органами управления или членами
              Ассоциации, на основании оценки их профессионального уровня и
              экспертной компетенции.
            </p>
            <p>
              3.3.6. Комитет осуществляет экспертную оценку кандидатов на основе
              представленных документов и при необходимости проводит дополнительные
              процедуры, включая запрос информации и проведение собеседования.
            </p>
            <p>
              3.3.7. По результатам рассмотрения кандидатуры Комитет формирует
              письменное мотивированное заключение, содержащее оценку соответствия
              кандидата установленным критериям и рекомендацию о приеме либо отказе
              в приеме в Ассоциацию.
            </p>
            <p>
              3.3.8. Заключение Комитета является обязательным этапом процедуры
              приема и направляется на рассмотрение Общего собрания членов
              Ассоциации.
            </p>

            <h3>3.4. Порядок приема в Ассоциацию</h3>
            <p>3.4.1. Для вступления в Ассоциацию кандидат подает заявление, включающее:</p>
            <ul>
              <li>
                подробное резюме с описанием профессионального опыта, достижений и
                реализованных проектов;
              </li>
              <li>документы, подтверждающие соответствие критериям членства;</li>
              <li>рекомендации от членов Ассоциации или отраслевых экспертов;</li>
              <li>
                письменное обязательство соблюдать Устав Ассоциации и участвовать в
                ее деятельности.
              </li>
            </ul>
            <p>
              3.4.2. Комитет по приему рассматривает заявление кандидата в течение
              установленного срока, в рамках которого может:
            </p>
            <ul>
              <li>проводить проверку достоверности предоставленных данных;</li>
              <li>запрашивать дополнительные материалы;</li>
              <li>
                организовывать собеседование с кандидатом (очно или дистанционно).
              </li>
            </ul>
            <p>
              3.4.3. По итогам рассмотрения Комитет принимает одно из следующих
              решений:
            </p>
            <ul>
              <li>рекомендовать кандидата к приему в Ассоциацию;</li>
              <li>отказать в рекомендации;</li>
              <li>направить материалы на дополнительное рассмотрение.</li>
            </ul>

            <h3>3.5. Принятие решения о членстве</h3>
            <p>
              3.5.1. Окончательное решение о приеме в члены Ассоциации принимается
              Общим собранием членов Ассоциации на основании заключения Комитета.
            </p>
            <p>
              3.5.2. Решение о приеме принимается путем голосования членов
              Ассоциации.
            </p>
            <p>
              3.5.3. Принятие кандидата в члены Ассоциации осуществляется при
              условии получения положительного решения по итогам голосования.
            </p>
            <p>
              3.5.4. В случае принятия кандидата в члены Ассоциации ему
              присваивается официальный статус члена Ассоциации, выдается именной
              сертификат, подтверждающий членство, а сведения о нем подлежат
              внесению в официальный реестр членов Ассоциации. Информация о новом
              члене, включая его имя и профессиональный статус, публикуется на
              официальном сайте Ассоциации как подтверждение признания его
              профессиональных достижений.
            </p>

            <h3>3.6. Основания для отказа в приеме</h3>
            <p>3.6.1. Основаниями для отказа в приеме в Ассоциацию являются:</p>
            <ul>
              <li>несоответствие установленным критериям;</li>
              <li>отсутствие подтвержденных профессиональных достижений или признания;</li>
              <li>предоставление недостоверной информации;</li>
              <li>наличие нарушений деловой этики или законодательства.</li>
            </ul>

            <h3>3.7. Подтверждение статуса члена Ассоциации</h3>
            <p>
              3.7.1. Члены Ассоциации обязаны периодически подтверждать соответствие
              установленным критериям, включая предоставление информации о своей
              профессиональной деятельности, достижениях и развитии бизнеса.
            </p>
            <p>
              3.7.2. Ассоциация вправе проводить повторную экспертную оценку
              деятельности членов с целью подтверждения их статуса и уровня
              профессионального соответствия.
            </p>
          </section>

          <section className="charter-section">
            <h2>4. Органы управления Ассоциации</h2>

            <h3>4.1. Высший орган управления — Общее собрание членов Ассоциации</h3>
            <p>
              4.1.1. Общее собрание членов Ассоциации (далее - Общее собрание)
              является высшим органом управления Ассоциации, состоящим из ее членов
              - предпринимателей, обладающих значительными профессиональными
              достижениями и признанием в бизнес-сообществе. Общее собрание
              принимает ключевые решения, определяющие стратегию, цели и
              направления деятельности Ассоциации.
            </p>
            <p>
              4.1.2. Общее собрание созывается не реже одного раза в год и
              рассматривает вопросы, связанные с развитием Ассоциации,
              утверждением отчетов о деятельности, финансовых показателей,
              бюджета, а также иные вопросы, входящие в его компетенцию.
            </p>
            <p>
              4.1.3. В рамках Общего собрания осуществляется обсуждение
              стратегических инициатив, формирование приоритетных направлений
              развития Ассоциации, а также рассмотрение вопросов, связанных с
              профессиональным сообществом и деятельностью ее членов.
            </p>
            <p>
              4.1.4. Каждый член Ассоциации обладает правом голоса на Общем
              собрании. Решения принимаются путем голосования большинством голосов
              присутствующих членов, если иное не предусмотрено настоящим
              Уставом.
            </p>
            <p>
              4.1.5. Общее собрание также рассматривает вопросы, связанные с
              приемом новых членов Ассоциации на основании заключения Комитета по
              приему, что обеспечивает участие профессионального сообщества в
              процессе признания новых членов.
            </p>
            <p>
              4.1.6. Внеочередное Общее собрание может быть созвано по инициативе
              Правления, Президента Ассоциации либо по требованию не менее одной
              трети членов Ассоциации для рассмотрения вопросов, требующих
              оперативного решения.
            </p>
            <p>
              4.1.7. Повестка дня Общего собрания формируется с учетом предложений
              органов управления и членов Ассоциации и доводится до сведения всех
              членов заранее, что обеспечивает прозрачность и вовлеченность
              участников в процесс принятия решений.
            </p>

            <h3>4.2. Исполнительный орган — Правление во главе с Президентом</h3>
            <p>
              4.2.1. Правление является коллегиальным исполнительным органом
              Ассоциации, осуществляющим руководство текущей деятельностью и
              реализацию стратегических решений, принятых Общим собранием.
            </p>
            <p>
              4.2.2. В состав Правления входят члены Ассоциации, обладающие
              значительным профессиональным опытом, признанием в
              бизнес-сообществе и управленческой компетенцией.
            </p>
            <p>
              4.2.3. Правление возглавляется Президентом Ассоциации, избираемым
              Общим собранием членов Ассоциации сроком на 3 года из числа наиболее
              авторитетных и признанных членов Ассоциации.
            </p>
            <p>
              4.2.4. Президент Ассоциации осуществляет общее руководство
              деятельностью Ассоциации, представляет ее интересы в отношениях с
              государственными органами, международными организациями, деловыми и
              профессиональными объединениями, а также иными третьими лицами.
            </p>
            <p>
              4.2.5. Президент Ассоциации действует от имени Ассоциации без
              доверенности, подписывает договоры и иные документы, издает
              внутренние акты и обеспечивает реализацию решений органов
              управления.
            </p>
            <p>
              4.2.6. Правление обеспечивает выполнение решений Общего собрания,
              координирует деятельность комитетов и структурных подразделений
              Ассоциации, а также разрабатывает и реализует стратегические и
              операционные планы развития.
            </p>
            <p>
              4.2.7. Заседания Правления проводятся на регулярной основе и
              направлены на принятие решений по вопросам текущей деятельности,
              анализ результатов работы Ассоциации и подготовку ключевых
              инициатив.
            </p>

            <h3>4.3. Контрольный орган — Ревизионная комиссия</h3>
            <p>
              4.3.1. Ревизионная комиссия является независимым контрольным органом
              Ассоциации, осуществляющим надзор за финансово-хозяйственной
              деятельностью и соблюдением принципов прозрачности и
              добросовестности.
            </p>
            <p>
              4.3.2. В состав Ревизионной комиссии избираются члены Ассоциации,
              обладающие необходимыми знаниями и опытом в области финансов, учета
              или управления, и не входящие в состав Правления.
            </p>
            <p>
              4.3.3. Ревизионная комиссия избирается Общим собранием членов
              Ассоциации сроком на 2 года.
            </p>
            <p>4.3.4. К основным функциям Ревизионной комиссии относятся:</p>
            <ul>
              <li>проведение проверок бухгалтерской и финансовой отчетности;</li>
              <li>контроль за соблюдением финансовой дисциплины;</li>
              <li>анализ использования денежных средств и имущества Ассоциации;</li>
              <li>подготовка заключений по результатам проверок.</li>
            </ul>
            <p>
              4.3.5. В случае выявления нарушений Ревизионная комиссия обязана
              представить соответствующее заключение Общему собранию членов
              Ассоциации для принятия решений.
            </p>
            <p>
              4.3.6. Результаты проверок оформляются в виде официальных заключений
              и могут доводиться до сведения членов Ассоциации посредством
              публикации на официальных ресурсах, что обеспечивает прозрачность
              деятельности и высокий уровень доверия.
            </p>
          </section>

          <section className="charter-section">
            <h2>5. Имущество и финансовая деятельность Ассоциации</h2>

            <h3>5.1. Источники формирования имущества Ассоциации</h3>
            <p>5.1.1. Имущество Ассоциации формируется за счет следующих источников:</p>
            <ul>
              <li>
                членские взносы — обязательные платежи, вносимые членами
                Ассоциации, размер и порядок уплаты которых утверждаются Общим
                собранием;
              </li>
              <li>
                добровольные пожертвования и целевые взносы от физических и
                юридических лиц, заинтересованных в поддержке деятельности
                Ассоциации;
              </li>
              <li>
                доходы от организации международных и отраслевых мероприятий,
                включая форумы, конференции, семинары и иные профессиональные
                события;
              </li>
              <li>
                гранты, субсидии и иные формы финансовой поддержки,
                предоставляемые государственными, международными и иными
                организациями для реализации программ и проектов Ассоциации;
              </li>
              <li>
                доходы, полученные в рамках партнерских и совместных программ с
                коммерческими и некоммерческими организациями.
              </li>
            </ul>
            <p>
              5.1.2. Ассоциация вправе владеть, пользоваться и распоряжаться
              движимым и недвижимым имуществом, денежными средствами, банковскими
              вкладами, ценными бумагами и иными активами в соответствии с
              законодательством.
            </p>
            <p>
              5.1.3. Финансовая деятельность Ассоциации осуществляется на
              принципах прозрачности и подотчетности. Все поступления и расходы
              подлежат обязательному учету, а результаты финансовой деятельности
              отражаются в ежегодной отчетности.
            </p>

            <h3>5.2. Использование имущества</h3>
            <p>
              5.2.1. Имущество Ассоциации используется исключительно для
              достижения целей и реализации задач, предусмотренных настоящим
              Уставом, включая:
            </p>
            <ul>
              <li>
                организацию и проведение профессиональных, экспертных и
                международных мероприятий;
              </li>
              <li>
                развитие образовательных и аналитических программ, направленных
                на повышение профессионального уровня членов Ассоциации;
              </li>
              <li>
                поддержку инициатив, способствующих развитию предпринимательства,
                инноваций и деловой среды;
              </li>
              <li>
                реализацию социальных, благотворительных и общественно значимых
                проектов.
              </li>
            </ul>
            <p>
              5.2.2. Распоряжение имуществом осуществляется в соответствии с
              решениями органов управления Ассоциации и действующим
              законодательством.
            </p>
          </section>

          <section className="charter-section">
            <h2>6. Реорганизация и ликвидация</h2>

            <h3>6.1. Реорганизация Ассоциации</h3>
            <p>
              6.1.1. Реорганизация Ассоциации может осуществляться в форме
              слияния, разделения, преобразования или присоединения к другой
              организации.
            </p>
            <p>
              6.1.2. Решение о реорганизации принимается Общим собранием
              большинством голосов, если иное не предусмотрено законодательством.
            </p>
            <p>
              6.1.3. При реорганизации имущество, активы и обязательства
              передаются правопреемнику в соответствии с законодательством.
            </p>

            <h3>6.2. Ликвидация Ассоциации</h3>
            <p>
              6.2.1. Ликвидация Ассоциации может быть проведена по решению Общего
              собрания либо по требованию суда в случае нарушения законодательства.
            </p>
            <p>
              6.2.2. Для проведения ликвидации назначается ликвидационная
              комиссия, которая берет на себя все полномочия по управлению делами
              Ассоциации.
            </p>
            <p>
              6.2.3. Ликвидационная комиссия проводит инвентаризацию имущества,
              удовлетворяет требования кредиторов и составляет ликвидационный
              баланс.
            </p>
            <p>
              6.2.4. Оставшееся имущество направляется на достижение целей,
              предусмотренных Уставом, либо на благотворительные нужды в
              соответствии с решением Общего собрания.
            </p>
            <p>
              6.2.5. Ликвидация считается завершенной после внесения записи в
              государственный реестр.
            </p>
          </section>

          <section className="charter-section">
            <h2>7. Заключительные положения</h2>

            <h3>7.1. Действие Устава</h3>
            <p>
              7.1.1. Настоящий Устав вступает в силу с момента его утверждения
              Общим собранием членов Ассоциации и государственной регистрации в
              установленном законодательством порядке.
            </p>
            <p>
              7.1.2. Все положения Устава обязательны для исполнения Ассоциацией,
              ее членами, органами управления и должностными лицами.
            </p>

            <h3>7.2. Изменения и дополнения</h3>
            <p>
              7.2.1. Изменения и дополнения в Устав принимаются решением Общего
              собрания членов Ассоциации квалифицированным большинством голосов
              (не менее двух третей от числа присутствующих).
            </p>
            <p>
              7.2.2. Все изменения и дополнения подлежат государственной
              регистрации и вступают в силу с момента внесения соответствующей
              записи в единый государственный реестр юридических лиц.
            </p>
            <p>
              7.2.3. Члены Ассоциации уведомляются о внесении изменений в Устав в
              течение 30 дней с момента их регистрации.
            </p>

            <h3>7.3. Урегулирование вопросов, не предусмотренных Уставом</h3>
            <p>
              7.3.1. В случае, если какие-либо вопросы не урегулированы настоящим
              Уставом, их решение осуществляется в соответствии с
              законодательством, действующим на территории страны регистрации
              Ассоциации.
            </p>
            <p>
              7.3.2. Дополнительно могут применяться внутренние правила и
              регламенты Ассоциации, утвержденные Общим собранием.
            </p>

            <h3>7.4. Ответственность членов Ассоциации</h3>
            <p>
              7.4.1. Члены Ассоциации несут ответственность за соблюдение
              настоящего Устава и выполнения своих обязанностей в рамках целей и
              задач Ассоциации.
            </p>
            <p>
              7.4.2. Нарушение положений Устава может повлечь дисциплинарные меры,
              включая временное приостановление или прекращение членства.
            </p>

            <h3>7.5. Информационная открытость</h3>
            <p>
              7.5.1. Ассоциация обязуется обеспечивать информационную открытость
              своей деятельности, включая публикацию отчетов, решений Общего
              собрания, ключевых событий и достижений.
            </p>
            <p>
              7.5.2. Информация о деятельности Ассоциации размещается на ее
              официальном веб-сайте и в иных открытых источниках в соответствии с
              законодательством.
            </p>

            <h3>7.6. Порядок разрешения споров</h3>
            <p>
              7.6.1. Все споры, возникающие между членами Ассоциации, а также
              между членами и органами управления Ассоциации, разрешаются путем
              переговоров или с привлечением третейского суда Ассоциации.
            </p>
            <p>
              7.6.2. В случае невозможности урегулирования спора мирным путем, он
              подлежит рассмотрению в суде по месту нахождения Ассоциации.
            </p>

            <h3>7.7. Прекращение деятельности Ассоциации</h3>
            <p>
              7.7.1. В случае ликвидации или реорганизации Ассоциации, положения
              о порядке прекращения ее деятельности регулируются соответствующими
              разделами настоящего Устава.
            </p>

            <h3>7.8. Заключительная декларация</h3>
            <p>
              7.8.1. Ассоциация обязуется следовать принципам добросовестности,
              прозрачности и взаимоуважения в своей деятельности, внося вклад в
              развитие и укрепление профессионального сообщества.
            </p>
            <p>
              7.8.2. Настоящий Устав является основополагающим документом,
              определяющим внутреннюю структуру и принципы функционирования
              Ассоциации.
            </p>
          </section>
        </main>
      </div>
    </>
  );
};

export default CharterPage;